const ja = {
  10000001: 'SuperEx 2周年記念イベント',
  10000002: 'サインインして豪華な特典を受け取りましょう',
  10000003: '参加者数に応じて賞金総額が増え、最大10,000USDTとなる。',
  10000004: 'SuperEx 2周年記念イベント',
  10000005: '先物取引コンテストで20000USDTを獲得',
  10000006: `最大 <span style="color: #ffc72b;">10,000</span> USDTのボーナスプールをアンロックする先物取引高ランキング大会 `,
  10000007: 'フューチャーズ選手権',
  10000008: '先物取引コンテストで20000USDTを獲得',

  10000009: '選択してください',
  10000010: '発行総量',
  10000011: 'ブロッククエリ',
  10000012: '戻る',
  10000013: '次のステップ',
  10000014: '前のステップ',
  10000015: '情報を入力してください',
  10000016: 'トークン名を入力してください',
  10000017: '通貨の正式名称を入力してください',
  10000018: '了解しました',
  10000019: 'サブタイトルの名前を入力してください',
  10000020: '通貨の流通量を入力してください',
  10000021: '完了',
  10000022: 'その後、取引ペアの統計データはウェブサイトのFree Marketページで確認できます。',
  10000023: '{currency} 上場済！',
  10000024: '年',
  10000025: '月',
  10000026: '日',

  8000067: 'データ統計',
  8000068: 'トークン名',
  8000069: 'メインチェーンまたはプロトコル',
  8000070: 'コントラクトアドレスまたはTICKER',
  8000071: '副本のタイトル',
  8000072: 'コピーの作成時間',
  8000073: 'コピーのステータス',
  8000074: '累計分配金額/U',
  8000075: '先週の分配金額/U',
  8000076: '先週の取引金額/U',
  8000077: '先週の取引回数',
  8000078: '取引ペアの作成',
  8000079: '延期',
  8000080: '上場済み',
  8000081: '近日下場予定',
  8000082: '下場済み',
  8000083: '通貨を確認する',
  8000084: 'コイン上場のヒント',
  8000085: '作成が成功しました',
  8000086: '自由区上場',
  8000087: 'SuperExでは、簡単にかつ無料で取引所の上場を完了し、最大80%の取引手数料配当の機会があります。',
  8000088: 'コインを上場する方法?',
  8000089: '新しい取引ペアの作成',
  8000090: '私はコインを上場します',
  8000091: '取引ペアの複製を作成する',
  8000092: 'SuperEx取引所',
  8000093: 'なぜ私たちを選ぶべきですか？',
  8000094: '多様な選択肢',
  8000095: '多くのチェーンとプロトコルをサポートしています。BSCチェーン、ETHチェーン、SOLチェーンを含みます。',
  8000096: '人工的な審査なしで即座に上場し、分散型の上場手続きや注文簿での注文の利便性を体感することができます。',
  8000097: 'APIをサポートしています',
  8000098: 'APIインターフェースを使用してマーケットメイクやトレードを行うことで、操作がより効率的かつ自動化されます。',
  8000099: 'プラットフォームの露出',
  8000100: '現物自由区で上場し、SuperExの数百万人のユーザートラフィックを享受し、より多くの注目を集めることができます。',
  8000101: '初心者でも経験豊富なトレーダーでも、当社のトレードペア作成プラットフォームは新しい体験と機会を提供します。今すぐあなただけのトレードペアを作成し、取引手数料の分配収益を享受しましょう！',
  8000102: 'トータルアセットが{resultData}U以上である場合にのみ、トレードペアを作成する資格があります。',
  8000103: '取引所',
  8000104: '好きな仮想通貨を選んで、USDTと組み合わせて取引ペアを作成し、独自の取引商品を作り出すことができます。',
  8000105: '手数料分配を受け取る',
  8000106: '作成した取引ペアのコピーの取引額が一定の閾値に達すると、一部の取引手数料が配当として返還されます。これにより、取引ペアのコピーを作成したあなたも取引収益を共有することができます。',
  8000107: '現在、制限されたユーザーのため、新しい取引ペアを作成することはできません。明日再試してください。',
  8000108: '言語を選択してください',
  8000109: 'ホワイトペーパー',
  8000110: 'その通貨は上場が禁止されています！',
  8000111: 'その通貨はすでにSuperExのメインボード取引エリアに存在しているため、取引ペアを作成することはできません！',
  8000112: '有効な契約アドレス/Ticker',
  8000113: 'あなたの現物メインボードのET残高が不足しています。新しい取引ペアを作成するには{num}ETの管理料を支払う必要があります。再度充電してください。',
  8000114: '今日、新しいコインの作成中に入力ミスが多すぎたため、今日は新しいコインの申請を行うことができません。明日再試してください。',
  8000115: 'その通貨は既に存在しているため、今はあなたの取引ペアのコピーを作成します！',
  8000116: '以下は確認する情報です：',
  8000117: '通貨の小数点以下の桁数',
  8000118: 'コインを自由に上場する方法',
  8000119: '通貨の正式名称',
  8000120: '通貨の価格の小数点以下の桁数',
  8000121: 'SUPEREXコイン上場：<em class="normal" style="color: #0CAA6D;">上場手数料0！</em><em class="normal" style="color: #1D90F5;">コミュニケーションコスト0！</em> 1分で取引所に上場でき、最大<em class="normal" style="color: #F65D62;">80%の利益分配</em>を享受できます。',
  8000122: '英文通貨紹介',
  8000123: '必須入力情報：',
  8000124: '入力した副題の名前は既に存在しています。もう一度入力してください！',
  8000125: '以下は任意の情報です：',
  8000126: 'メインチェーンまたはプロトコルと、それに対応する管理費を選択してください',
  8000127: '第一歩: 新しいコインの契約アドレスをコピーして貼り付けます。',
  8000128: '契約アドレス/ティッカーを入力してください',
  8000129: '作成を確認します',
  8000130: '取引ペアのコピー{currency}が正常に作成されました！',
  8000131: '第二ステップ：このコインが初めて取引所に上場する場合、コインの紹介やロゴ画像のアップロードなど、いくつかの基本情報を入力する必要があります。',
  8000132: 'BTCプロトコル市場',
  8000133: '第三ステップ：作成した取引ペアのコピーに名前を付けるだけです。そして、上場手続きが完了し、このコインは一般に取引可能になります。',
  8000134: 'トークンをリストする',
  8000135: '発行総量を入力してください',
  8000136: '第四ステップ：あなたのコピーの週間取引額が一定の閾値に達したら、そのコピーから取引手数料の分配を受け取ることができます。',
  8000137: '8を選択した場合、暗号通貨の価格が0.00000001まで表示されることを意味します。例えば、BTCの価格は$72186.12345678と表示されます。ほとんどのMEMEコインには11を選択することをお勧めします。',
  8000138: '入力してください',
  8000139: '私はコインの上場を始めます',
  8000140: '英語で通貨の簡単な紹介を入力してください',
  8000141: 'インスタンスは同じ取引ペアに複数のバージョンが存在することを意味し、その一つがあなたが作成したインスタンスです。他のユーザーはインスタンス名でこれらのバージョンを区別します。ユーザーがあなたのインスタンスを選んで取引を行えば、相応の取引手数料コミッションを受け取るチャンスがあります。',
  8000142: 'メールの形式が正しくありません。',
  8000143: 'ブロック検索アドレス',
  8000144: '通貨の流通量',
  8000145: '通貨の流通量は1〜20桁の正の整数で制限されています',
  8000146: '通貨のアイコン',
  8000147: 'PNGまたはJPG形式をサポートし、ファイルサイズは5 MB以内で、1日につき最大10回のアップロードが制限されています',
  8000148: '通貨の発行時間',
  8000149: '発行時間を選択してください',
  8000150: 'ホワイトペーパーのリンクを入力してください',
  8000151: '公式ウェブサイト',
  8000152: '公式ウェブサイトのリンクを入力してください',
  8000153: '現物自由区上場',
  8000154: '取引所であなたのトークン上場をリクエストする',
  8000155: '通貨の略称の入力制限は9文字で、数字、英字、および英語の記号のみがサポートされます',
  8000156: '通貨の正式名称の入力制限は50文字で、数字、スペース、英字、および英語の記号のみがサポートされます',
  8000157: '発行総量は1〜20桁の正の整数で制限されています',
  8000158: '文の始めや終わりの文字はスペースにできず、連続するスペースは許可されません。「/」記号と絵文字はサポートされていません。',
  8000159: '1. 上場申請者は情報の真実性について自己責任を持つ必要があり、プラットフォームはいつでもトークンまたは取引ペアを停止する権利を有し、情報内容をいつでも調整する権利を有します。',
  8000160: '2. 上場申請者は上場トークンについて十分な調査を行い、合理性、規制遵守、合法性に責任を持つ必要があります。プラットフォームは、トークンのスマートコントラクトに悪意のある行為や有害な行為がある場合、直ちにそのトークンを停止し、ユーザーの代理人として上場申請者に対して損害賠償を請求する権利を有します。',
  8000161: '3. 上場申請者または他の人がその後にトークン情報を調整したい場合、弊社のカスタマーサービスに連絡する必要があります。',
  8000162: '4. ユーザーの利益を保護し、不良通貨を排除するため、上場ユーザーが作成した取引ペアが当社プラットフォームの取引量要件を満たさない場合、約1週間以内に上場廃止の通知が行われます。 毎週月曜日に、プラットフォームは準拠していない取引ペアに対して上場廃止通知を発行します。その時点でも、上場通貨ユーザーは 5 日以内に上場廃止を申請する機会があります。 遅延上場廃止の申請が成功した場合は、さらに 4 週間の観察期間が与えられますが、そうでない場合は上場廃止となります。',
  8000163: '5. 上場者が作成した取引ペアのコピーがプラットフォームの配当基準を満たす取引額に達した場合、対応する手数料配当を受け取ることができます。',
  8000164: 'あなたは基軸デジタルコインを広めるために、運営活動やマーケティングに使用する一定量のトークンを提供することに同意しますか？',
  8000165: '6. 上席者はプラットフォームのカスタマーサービスに連絡して、市場メーカーの資格を申請することができます。',
  8000166: '作成する',
  8000167: '取引ペアのコピー{currency}を作成し、現物メインボードアカウントから{upFee} ETを差し引く予定です',
  8000168: 'いいえ',
  8000169: 'はい',
  8000170: 'あなたのメールアドレスを入力してください。そうすれば、我々のマーケティング運営チームがご連絡します',
  8000171: '推薦者や連絡先の人はいますか？',
  8000172: '推薦者の名前または連絡先を入力してください',
  8000173: 'このボックスをチェックすると、すべての関連リスクを負うことに同意し、私たちの<a id="service_href" class="pointer" style="color: #D9A31A;text-decoration: underline" target="_self">利用規約</a>に同意したことになります。',
  8000174: '上場の収益を得る',
  8000175: '取引所に上場する権利',
  8000176: '現在、この通貨は上場をサポートしていません！',
  8000177: '情報を入力してください',
  8000178: '共有しに行く',
  8000179: '上場済！',
  8000180: '自由区上場、富の自由を開始',
  8000181: 'SuperExで{symbol}の取引ペアを作成しました！月へ！',
  8000182: '各配当金額は月曜日に更新されますが、実際の配布過程で最大3営業日の遅延が発生する可能性があります。「ウォレット履歴」-「その他」-「メインマーケット」の下で、「報酬を送る」タイプを通じて関連記録を確認することができます。',
  8000183: 'Twitterアカウント',
  8000184: 'Telegramアカウント',
  8000185: 'Discordアカウント',
  8000186: '有効なTwitterリンクを入力してください！',
  8000187: '有効なTelegramリンクを入力してください！',
  8000188: '有効なDiscordリンクを入力してください！',
  8000189: 'Twitterリンクを入力してください',
  8000190: 'Telegramリンクを入力してください',
  8000191: 'Discordリンクを入力してください',
  8000192: '申し訳ありませんが、この通貨のスマートコントラクトの内容や関連する権限設定には高いセキュリティリスクがあります。他の通貨を試してください。',
  8000193: '申し訳ありませんが、この通貨のスマートコントラクトの内容に潜在的なリスクがあるため、現在はリストできません。他の通貨を試してください。',
  8000194: '注意事項：',
  8000195: 'この通貨の入金を完了してからでないと、売り注文を出すことはできません。',
  8000196: 'USDTを自由区に移動してからでないと、買い注文を出すことはできません。',
  8000197: 'APIを接続してからでないと、市場作りの取引は行えません。',
  8000198: 'カスタマーサービスに連絡',
  8000199: '5から12の間の整数を入力してください',

  8100013: '公式認証チャンネル',
  8100014: '確認情報を入力してください',
  8100015: '以下の内容の確認が可能です',
  8100016: 'SUPEREX.COMの公式メールのみ',
  8100017: '公式BD身分証明',
  8100018: '例：Telegram/X（Twitter）公式アカウント',
  8100019: '上場チャンネル認証',
  8100020: '契約締結や支払いが必要な場合、必ず公式BDに確認してください',
  8100021: '<a href="/" style="color: #FFC72B" class="under-line pointer">SUPEREX.COM</a>へのご関心に感謝し、皆様の権益が侵害されないよう最大限努力いたします。',
  8100022: '非公式SuperExチャンネル',
  8100023: 'SuperEx公式チャンネル',
  8100024: '入力された<em class="normal activeColor">{keyWord}</em>はSuperExの公式チャンネルではありません。資産の安全にご注意いただき、個人情報を保護してください。',
  8100025: 'ご照会内容の<em class="normal activeColor">{keyWord}</em>は{note}です。',
  8100026: 'セキュリティのヒント',
  8100027: '· 認証されていないアカウントとやり取りしないでください。',
  8100028: '· ウォレットのニーモニックフレーズ、SuperExに登録されているメールアドレス、電話番号、パスワードを誰にも教えないでください。',
  8100029: '· 追加のサポートが必要な場合は、サポート(support@superex.com)にお問い合わせください。',
  8100030: '{userName}の大きなおくりものを受け取った！',
  8100031: 'ギフトを開く',
  8100032: '最後のステップが残っています！',
  8100033: '今すぐSuperExをダウンロードして、友達のギフトを受け取りましょう！',
  8100034: 'ギフトを諦める',
}
export default  ja



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/ja.js